import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-box2-icon',
  templateUrl: './shopping-box2.component.html'
})
export class ShoppingBox2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
